<app-onboarding-profile-shell [showBack]="true"
  (back)="handleBack()">
  @if (firstName()) {
    <p shellEyebrow
      class="tw-mb-2 tw-text-300 tw-font-normal tw-uppercase tw-leading-1.2 tw-text-gray-800"
      i18n="@@hiPatientName">Hi {{ firstName() }}</p>
  }
  <div shellHeading
    class="tw-font-bold tw-leading-1.2 tw-text-gray-800"
    [class.tw-text-600]="isDravidianScriptUser()"
    [class.tw-text-700]="!isDravidianScriptUser()"
    i18n="@@howOldAreYou">How old <br/> are you?</div>

  <input class="tw-m-0 tw-h-12 tw-w-full tw-rounded-2.5 tw-border tw-border-solid tw-bg-gray-100 tw-px-3 tw-font-body tw-text-300 tw-text-gray-800 placeholder:tw-text-left placeholder:tw-text-300 placeholder:tw-font-normal placeholder:tw-text-gray-400"
    #ageInput
    id="ageInput"
    name="age"
    type="text"
    inputmode="numeric"
    pattern="[0-9]*"
    autocomplete="off"
    [attr.maxlength]="MAX_AGE_DIGITS"
    [class.tw-border-gray-300]="!isFilled() && !hasError()"
    [class.tw-border-teal-400]="isValidAndFilled()"
    [class.tw-border-orange-500]="hasError()"
    [ngModel]="age()"
    (input)="onAgeInput($event)"
    (keydown)="commonUtilityHelper.limitInputByMaxDigit($event, MAX_AGE_DIGITS)"
    (paste)="onInputPaste($event)"
    placeholder="enter age here"
    i18n-placeholder="@@enterAgeHere" />
  @if (hasError()) {
    <app-onboarding-profile-field-error id="ageError">
      @if (errorMessage() === GenderFormErrorMessages.underAged) {
        <span i18n="@@ageErrorUnderageV2">As you are under-age, presence and consent of your parent is required. Sorry, you will not be able to proceed further.</span>
      }
      @if (errorMessage() === GenderFormErrorMessages.invalidAge) {
        <span i18n="@@ageErrorInvalidAgeV2">Please enter a valid age.</span>
      }
      @if (errorMessage() === GenderFormErrorMessages.enterAge) {
        <span i18n="@@enterAgeV2">Enter your age to continue</span>
      }
    </app-onboarding-profile-field-error>
  }

  <button shellFooter
    csButton
    id="continueBtn"
    type="button"
    class="tw-w-full"
    [loading]="loading()"
    (click)="handleContinue()"><span i18n="@@continueNew">Continue</span>
  </button>
</app-onboarding-profile-shell>
